import * as Sentry from "@sentry/tanstackstart-react";

export function initSentry({ release, environment, ...overrides }) {
  Sentry.init({
    dsn: "https://c44e296f7fafc28f6a772c3c72e1f8bf@o4508749958152192.ingest.de.sentry.io/4508749965099088",
    sendDefaultPii: true,
    enableLogs: true,
    tracesSampleRate: 1.0,
    enabled: environment === "production",
    release,
    environment,
    ...overrides,
  });
}
